module.exports = __webpack_public_path__ + "static/media/previewImageBackground.f307827e.png";